import React from 'react'
import PropTypes from 'prop-types'
import DashTitleDivider from 'Components/DashTitleDivider'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'
import ButtonCard from 'Components/ButtonCard'

const WholesalePage = props => {
    return (
        <div>
            <SubPageBreadCrumbs />
            <div style={{ display: 'flex' }} >
                <ButtonCard link='/wholesale/species-database' title={'Species Database'} blue />
                <ButtonCard link='/wholesale/product-list' title={'B2B Product List'} blue />
                <ButtonCard link='/wholesale/bulk-orders' title={'Bulk Orders'} blue />
                <ButtonCard link='/wholesale/market-request' title={'Market Request'} blue />
                <ButtonCard link='/wholesale/buyer-orders' title={'Buyer Orders'} blue />
            </div>
        </div>
    )
}

WholesalePage.propTypes = {}

export default WholesalePage